var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMonitoring = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 -960 960 960"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M120-120v-80l80-80v160zm160 0v-240l80-80v320zm160 0v-320l80 81v239zm160 0v-239l80-80v319zm160 0v-400l80-80v480zM120-327v-113l280-280 160 160 280-280v113L560-447 400-607z"
})));
export default SvgIconMonitoring;